import React from 'react'
import { useSelector } from 'react-redux'

import type { RouteGuardProps } from '../routes.types'

import type { RootState } from '@/store/store'

export function OrganizationGuard({
    children,
    requireOrganization = false,
}: Pick<RouteGuardProps, 'children' | 'requireOrganization'>) {
    const { organization } = useSelector((state: RootState) => state.auth)

    // If organization is not required, skip check
    if (!requireOrganization) {
        return <>{children}</>
    }

    // Check organization requirement
    if (requireOrganization && !organization) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    padding: '2rem',
                }}
            >
                <div
                    style={{
                        padding: '3rem',
                        textAlign: 'center',
                        color: '#f59e0b',
                        backgroundColor: '#fffbeb',
                        border: '1px solid #fcd34d',
                        borderRadius: '0.5rem',
                        maxWidth: '500px',
                    }}
                >
                    <h2 style={{ margin: '0 0 1rem 0', fontSize: '1.5rem' }}>Organization Required</h2>
                    <p style={{ margin: '0 0 1rem 0' }}>This page requires you to be part of an organization.</p>
                    <p style={{ margin: '0' }}>Please contact your administrator for access.</p>
                </div>
            </div>
        )
    }

    return <>{children}</>
}
